import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {filter, map, take} from 'rxjs/operators';
import * as wjcCore from '@mescius/wijmo';
import {LoadUserAction} from '../ngrx/actions/user.action';
import {Capability, canWith, defaultRouteForRoles} from './roles';

/**
 * ルート data.capability に基づくアクセス制御ガード。
 *
 * <p>旧 AdminGuard の後継。ロール名直参照ではなく roles.ts のケーパビリティで
 * 判定する。システム管理者/旧 管理者 は全ケーパビリティを持つため従来どおり通る。
 *
 * <p>AdminGuard はハードリロード時に user 読込前へ canActivate が走り誤って
 * リダイレクトしていたが、本ガードは store の user.loaded を待ってから評価する。
 */
@Injectable()
export class CapabilityGuard implements CanActivate {

    constructor(private router: Router, private store: Store<any>) {
        this.store.dispatch(new LoadUserAction());
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const cap: Capability | Capability[] | null = next.data ? next.data['capability'] : null;
        return this.store.select<any>('activePromotionFeature').pipe(
            filter((feature: any) => wjcCore.isObject(feature.user) && feature.user.loaded),
            take(1),
            map((feature: any) => {
                const roles = feature.user.user ? feature.user.user.roles : null;
                if (!cap || canWith(roles, cap)) {
                    return true;
                }
                this.router.navigateByUrl(defaultRouteForRoles(roles));
                return false;
            }),
        );
    }
}
